export const IMG_PATH_NEW = 'https://testdevcdn.xylink.com/h5/sdk_doc/static/website/double-classroom/';
interface IScheme {
  title: string;
  desc: string;
  descM: string;
  icon: string;
}

export const scheme: IScheme[] = [
  {
    title: '全球部署',
    desc: '通过云计算连接万间课堂\n栩栩如生',
    descM: '通过云计算\n连接万间课堂\n栩栩如生',
    icon: `${IMG_PATH_NEW}pc/c03bbabb5ba94f8a07e742d24da306ec6982464acf4dd8c69726018db8e41f13.png`,
  },
  {
    title: '云端课堂',
    desc: '云端课堂再现教师真人大小\n高保真图像及声音',
    descM: '云端课堂再现\n教师真人大小\n高保真图像及声音',
    icon: `${IMG_PATH_NEW}pc/c314d967f47adbc5a236467e67052147a7e0a17e10fbc9bb61877f795b5e3132.png`,
  },
  {
    title: '按需定制',
    desc: '可根据实际应用场景需求\n量身定制双师课堂解决方案',
    descM: '可根据实际应用场景需求\n量身定制双师课堂\n解决方案',
    icon: `${IMG_PATH_NEW}pc/8921569391e9b307a80931a1058fa4a9758cc4f927d46d12758922c6cda94bf7.png`,
  },
  {
    title: '拓展兼容',
    desc: '与双师课堂专业硬件设备全兼容\n打造一站式授课/听课完美体验',
    descM: '专业硬件设备全兼容\n打造一站式授课\n听课完美体验',
    icon: `${IMG_PATH_NEW}pc/d21b28fdb883cddd186dee83bcc68013bb6fca6f49a63eac75279a21046dc29c.png`,
  },
];

interface IClassroom {
  decorate: string;
  title: string;
  descArr: string[];
  caseImg: { src: string; videoSrc?: string }[];
}

export const classroom1: IClassroom = {
  decorate: `${IMG_PATH_NEW}pc/dcde7ee352625aee93c126eb91891c2df0fca620e8027eccdb8c10a9bded240a.png`,
  title: '这是一间简单易用的双师课堂',
  descArr: ['基于互联网环境下大规模部署的高清课堂', '智能化授课端以及听课端设备使用简单', '万间教室集中管理，复制推广性价比极高'],
  caseImg: [
    {
      src: `${IMG_PATH_NEW}pc/e3a3cbb5418a16533a2780876771e2a3e90511c81787f7a07d285819331deebd.jpg`,
      videoSrc: 'http://devcdn.xylink.com/website/video/double__class-01.mp4',
    },
    {
      src: `${IMG_PATH_NEW}pc/3a408be3750afec467f835edabf45cfbe97012446f40fd298385fd05310314a9.jpg`,
      videoSrc: 'http://devcdn.xylink.com/website/video/double__class-02.mp4',
    },
  ],
};
export const classroom2: IClassroom = {
  decorate: `${IMG_PATH_NEW}pc/40a8568eddc0f5ac355236dcc9f4e4946495383117158c7d03016f08e3028340.png`,
  title: '这是一间百变大咖的双师课堂',
  descArr: ['设备扩展：电子白板、点阵笔、答题器、手写笔、无线传屏', '功能扩展：课前预约、课堂互动、课中管理、课后点播、考评', '平台扩展：教学系统SDK集成，可定制开发、兼容教学平台'],
  caseImg: [
    {
      src: `${IMG_PATH_NEW}pc/a9d57167ab1d28dde8322a951c8941aab2ebc2d0203e39fc04d8504cd9607de4.jpg`,
    },
    {
      src: `${IMG_PATH_NEW}pc/c644e85c6fa6add59ddf3416ba8e30c57623d98479f3aac8c8a3fbcb715f58fb.jpg`,
    },
    {
      src: `${IMG_PATH_NEW}pc/23b6c9d10f92e048529af9a56f519709afc260d41cffa4d213586a435bb7b46c.jpg`,
    },
  ],
};
export const classroom3: IClassroom = {
  decorate: `${IMG_PATH_NEW}pc/ab9dc55b00426c39432a6ce26888f4a59c5434e27a7c7b9f43cf992cb05cb80c.png`,
  title: '双师课堂听课端',
  descArr: ['十二倍光学变焦，无死角捕捉学生听课效果', '八米远距离拾音，保证教室任意角落声音清晰', '支持定制二次开发，集成多种教学设备功能模块'],
  caseImg: [
    {
      src: `${IMG_PATH_NEW}pc/e6fcbf9af087f3dd51d0852b00e135d3d9dedced30600673d2c2945d781571bb.jpg`,
    },
    {
      src: `${IMG_PATH_NEW}pc/c493176041e25bddb828c479ecefe7b0c1b8a0b74299277ed6bd6230ec40e2cc.jpg`,
    },
  ],
};
interface Introduce {
  icon: string;
  title: string;
  desc: string;
}
export const introduce1: Introduce[] = [
  {
    icon: `${IMG_PATH_NEW}mobile/58101e6c94814198270604cf62174c18cd79cf0a1da7151ed77f90734d21456a.jpg`,
    title: '这是一间简单易用的双师课堂',
    desc: '基于互联网环境下大规模部署的高清课堂\n智能化授课端以及听课端设备使用简单\n万间教室集中管理，复制推广性价比极高',
  },
  {
    icon: `${IMG_PATH_NEW}mobile/370a05a5a2c652a9b63dba87ddd4f5c032c907525a05a75d3e4df80902600d68.jpg`,
    title: '这是一间栩栩如生的双师课堂',
    desc: '核心音视频算法，保障互联网丢包环境下顺利上课\n自动负载均衡，异地多活，保证双师课堂不中断\n延时低至40ms，1080P保证实时高清流畅课堂效果',
  },
  {
    icon: `${IMG_PATH_NEW}mobile/b4a0ea547a05f2318119c8261c2757cf1eae1e34e52238bc092877f63e67cd6b.jpg`,
    title: '这是一间百变大咖的双师课堂',
    desc: '设备扩展：电子白板、点阵笔、答题器、手写笔\n功能扩展：课前预约、课中互动管理、课后点播\n平台扩展：SDK集成，兼容教学系统二次开发',
  },
];
export const introduce2: Introduce[] = [
  {
    icon: `${IMG_PATH_NEW}mobile/b541b3331a9ac0149a32d84f52c85ff55be322261e2ea515b1ae000fe0477ca7.jpg`,
    title: '双师课堂授课端',
    desc: '20倍光学变焦，十六分屏显示，完美呈现教学细节\n专业云视频硬件终端，还原真实课堂互动效果\n专业的音视频终端方案，搭配双师课堂专业设备',
  },
  {
    icon: `${IMG_PATH_NEW}mobile/ba14b461f4c6f715e755018dcba1d93143166688945ffef70313a0ab3e9b3243.jpg`,
    title: '双师课堂听课端',
    desc: '十二倍光学变焦，无死角捕捉学生听课效果\n八米远距离拾音，保证教室任意角落声音清晰\n支持定制二次开发，集成多种教学设备功能模块',
  },
];

interface IMobileVideo {
  title: string;
  videoSrc: string;
  src: string;
}
export const mobileVideo: IMobileVideo[] = [
  {
    title: '双师课堂授课教室',
    videoSrc: 'http://devcdn.xylink.com/website/video/double__class-01.mp4',
    src: `${IMG_PATH_NEW}mobile/3d3c480cf959bbf70008ddb20f481a2bf961037c90d38a40f6192c2def53ad2a.jpg`,
  },
  {
    title: '双师课堂听课教室',
    videoSrc: 'http://devcdn.xylink.com/website/video/double__class-02.mp4',
    src: `${IMG_PATH_NEW}mobile/cdc3190621f05864c714c9e6cdf1f179a37a5b53a8b0fc064861f11c8096d7d5.jpg`,
  },
];
